import * as shape from 'd3-shape';
import { ChartComponentType } from '../enums/chart-component-type.enum';

export class Chart {
  name: string;
  value: string | number;
  series?: Array<Chart>;
}

export class ChartComponent {
  // tslint:disable-next-line: typedef
  public static defaultColorScheme = {
    domain: [
      '#EF5350',
      '#FFCA28',
      '#FB8C00',
      '#EC407A',
      '#AB47BC',
      '#7E57C2',
      '#5C6BC0',
      '#42A5F5',
      '#0277BD',
      '#26C6DA',
      '#26A69A',
      '#66BB6A',
      '#9CCC65',
      '#FFEE58',
      '#8D6E63',
      '#9E9E9E',
      '#78909C',
    ],
  };

  constructor(type: ChartComponentType, elementId?: string) {
    switch (type) {
      case ChartComponentType.LINE_BILLING:
        return {
          show: false,
          isLoading: true,
          chartUpdateTime: null,
          colorScheme: {
            domain: ['#00897B'],
          },
          resultDashboarBilling: [],
          gradient: false,
          showXAxis: true,
          showYAxis: true,
          showLegend: true,
          showXAxisLabel: true,
          showYAxisLabel: true,
          autoScale: false,
          curve: shape.curveLinear, //shape.curveCardinal,
          roundDomains: true,
          timeline: true,
          yAxisLabel: 'Faturamento',
          xAxisLabel: 'Últimos 7 dias',
        };

      case ChartComponentType.LINE_ORDER:
        return {
          show: false,
          isLoading: true,
          chartUpdateTime: null,
          colorScheme: {
            domain: ['#EE8471', '#F5BE31', '#A4D6C5', '#777777'],
          },
          customColors: [],
          data: [],
          summary: {
            total: 0,
            finished: 0,
            cancelled: 0,
          },
          gradient: true,
          showXAxis: true,
          showYAxis: true,
          showLegend: true,
          showXAxisLabel: true,
          showYAxisLabel: true,
          autoScale: false,
          curve: shape.curveLinear, //shape.curveCardinal,
          roundDomains: true,
          yAxisLabel: 'Pedidos',
          xAxisLabel: 'Últimos 7 dias',
          timeline: true,
          legendTitle: 'Status',
        };

      case ChartComponentType.PIE_ORDERS:
        return {
          // viewOrderSummary: [900, 200],
          colorScheme: {
            domain: ['#F44336', '#EE8471', '#F5BE31', '#039BE5', '#A4D6C5', '#AAAAAA'],
          },
          orderSummaryChartData: [],
          gradient: false,
        };

      case ChartComponentType.BAR_SALES:
        return {
          elementId: elementId,
          show: false,
          isLoading: true,
          chartUpdateTime: null,
          segmentSelected: 'finished',
          graph: 'pie',
          total: 0,
          totalFinished: 0,
          totalCanceled: 0,
          data: [],
          finishedData: [],
          canceledData: [],
          colorScheme: ChartComponent.defaultColorScheme,
        };

      case ChartComponentType.GENERIC:
        return {
          elementId: elementId,
          show: false,
          isLoading: true,
          selectedItem: null,
          originalData: [],
          data: [],
          total: 0,
          chartUpdateTime: null,
          // colorScheme: {
          // 	domain: ['#EE8471', '#F5BE31', '#7E57C2', '#3949AB', '#1E88E5', '#00ACC1',
          // 		'#00897B', '#43A047', '#FDD835', '#F4511E', '#6D4C41', '#757575', '#546E7A']
          // }
          colorScheme: ChartComponent.defaultColorScheme,
          legendColors: [],
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/chart.model.ts